export const crmGettingStartedArticle = {
  title: 'Customer CRM: Getting Started',
  slug: 'crm-getting-started',
  content: `Customer CRM: Getting Started

Use the Customer CRM to manage contacts, companies, and your deal pipeline in one workspace.

1) Open the CRM
- Navigate to /crm to reach the Customer CRM hub.
- The header shows live workspace metrics and quick tabs (Overview, Contacts, Companies, Deals, Activities, Telemarketing, Settings).

2) Overview tab (\"Overview\")
- Review key metrics at the top of the CRM.
- Use the quick access cards to jump to Contacts, Companies, Deals, or Activities.
- Import historical data using the Import modal (CSV templates included).

3) Contacts tab (\"Contacts\")
- Search and filter contacts by lifecycle stage (Lead → Customer).
- Switch between Table, Kanban, and Gallery views.
- Use Quick Add for fast entry (first name + email required).
- Use Full Form for deeper fields (phone, address, etc.).
- Open a contact record for full details (View button).
- Create a deal directly from a contact using + Deal.

4) Companies tab (\"Companies\")
- Search and filter companies.
- Switch between Table, Kanban, and Gallery views.
- Quick Add requires a company name; industry and website are optional.
- Open a company record to view details.

5) Deals tab (\"Deals\")
- View the deal pipeline in the Deals board.
- Track stages and manage opportunities.

6) Activities tab (\"Activities\")
- Switch between Activity Feed and Calendar view.
- Use the feed to review recent CRM actions.
- Use the calendar for scheduled meetings and tasks.

7) Telemarketing
- Use the Telemarketing tab to run AI-powered call campaigns (book meetings flow).
- Create and monitor campaigns from /crm/telemarketing.

8) Settings tab (\"Settings\")
- Manage team members, permissions, and workspace configuration.

Tips
- If you see \"No Organization Selected\", create or select a workspace first.
- Use Cmd/Ctrl + K to open the CRM command palette from the CRM hub.
`,
};
